var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBsc = function SvgBsc(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#000",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f0b90b",
    d: "M7.454 6.449 12 4l4.547 2.449-1.667.907L12 5.809 9.125 7.356zm9.093 3.093-1.667-.906L12 10.182 9.125 8.636l-1.671.906v1.81l2.87 1.546v3.089l1.676.906 1.672-.906v-3.09l2.875-1.546zm0 4.903V12.63l-1.667.907v1.809zm1.19.64-2.876 1.542v1.813l4.547-2.453v-4.898l-1.672.902zm-1.672-7.09 1.667.907v1.81l1.676-.903V7.996l-1.672-.907L16.065 8zm-5.74 9.29v1.808L12 20l1.672-.907V17.29l-1.672.9-1.671-.907zM7.453 14.44l1.667.907v-1.81l-1.667-.906v1.813zm2.87-6.444L12 8.902l1.672-.906L12 7.089 10.33 8zm-4.06.906 1.671-.906-1.666-.907L4.593 8v1.813l1.671.903V8.902m0 3.09-1.671-.903v4.898l4.546 2.453v-1.818L6.27 15.08v-3.093z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBsc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bsc.8e78908c558d43deec43e74606de5279.svg";